/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
import React from 'react'
import {PayloadRow} from '../../columns/PayloadRow'
import {EventDependentComponent} from '../areaContracts'
import intl from '../../utils/intl/intl'

export const SyncProfileTableView: EventDependentComponent = ({item}) => {
  const {discriminator1, payload} = item
  return (
    <>
      {discriminator1 ? (
        <PayloadRow payloadKey={intl.formatMessage('Profile Id')} value={discriminator1} />
      ) : null}
      {payload && payload.profileName ? (
        <PayloadRow payloadKey={intl.formatMessage('Profile Name')} value={payload.profileName} />
      ) : null}
    </>
  )
}
